class Response{
    constructor(success,data){
        this.success = success;
        this.data = data;
    }
}

export default Response;